class ScrollToForm {

  constructor() {
    this.hero = document.querySelector('.eventHero')
    this.aside = document.querySelector('.eventAside')
    this.listen()
  }

  listen() {
    this.hero.addEventListener('click', (ev) => {
      if (ev.target.classList.contains('button--register')) {
        document.querySelector('.zoomForm').scrollIntoView({behavior: "smooth"})
      }
    })
    this.aside.addEventListener('click', (ev) => {
      if (ev.target.classList.contains('button--register')) {
        document.querySelector('.zoomForm').scrollIntoView({behavior: "smooth"})
      }
    })
  }

}

export default ScrollToForm